import React, { useState } from "react";
import style from "css/landing.module.css";
import { ReactComponent as Arrow } from "asset/common/arrow.svg";

function Social() {
  const [isHover, setIsHover] = useState(false);
  const [hoverItem, setHoverItem] = useState("");

  const handleMouseOver = (menu) => {
    setIsHover(true);
    setHoverItem(menu);
  };

  const handleMouseOut = () => {
    setIsHover(false);
    setHoverItem("");
  };

  return (
    <div className={style.social_wrap}>
      <div
        className={style.social_item}
        onMouseOver={() => handleMouseOver("blog")}
        onMouseOut={handleMouseOut}
        onClick={() => window.open("https://blog.naver.com/rivsw", "_blank")}
      >
        <div className={style.social_logo_box}>
          <img
            src={
              isHover && hoverItem === "blog"
                ? `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/blog_over.webp"
                : `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/blog.webp"
            }
            alt="blog"
          />
        </div>
        <div className={style.social_link_wrap}>
          <Arrow
            fill={isHover && hoverItem === "blog" ? "#ffffff " : "#0a2cc4"}
            width="37px"
            height="37px"
          />
        </div>
        <div className={style.social_text_wrap}>
          <div className={style.social_text_title}>네이버 블로그</div>
          <div className={style.social_text_content}>
            리브테크놀로지의 최신 소식을 네이버 블로그에서 만나보세요.
          </div>
        </div>
      </div>
      <div
        className={style.social_item}
        onMouseOver={() => handleMouseOver("instagram")}
        onMouseOut={handleMouseOut}
        onClick={() =>
          window.open("https://www.instagram.com/rivtechnology/", "_blank")
        }
      >
        <div className={style.social_logo_box}>
          <img
            src={
              isHover && hoverItem === "instagram"
                ? `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/instagram_over.webp"
                : `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/instagram.webp"
            }
            alt="instagram"
          />
        </div>
        <div className={style.social_link_wrap}>
          <Arrow
            fill={isHover && hoverItem === "instagram" ? "#ffffff " : "#0a2cc4"}
            width="37px"
            height="37px"
          />
        </div>
        <div className={style.social_text_wrap}>
          <div className={style.social_text_title}>인스타그램</div>
          <div className={style.social_text_content}>
            다양한 현장 소식과 비하인드 스토리를 확인해 보세요.
          </div>
        </div>
      </div>
      <div
        className={style.social_item}
        onMouseOver={() => handleMouseOver("facebook")}
        onMouseOut={handleMouseOut}
        onClick={() =>
          window.open(
            "https://www.facebook.com/profile.php?id=61563844645879",
            "_blank"
          )
        }
      >
        <div className={style.social_logo_box}>
          <img
            src={
              isHover && hoverItem === "facebook"
                ? `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/facebook_over.webp"
                : `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/landing/social/facebook.webp"
            }
            alt="facebook"
          />
        </div>
        <div className={style.social_link_wrap}>
          <Arrow
            fill={isHover && hoverItem === "facebook" ? "#ffffff " : "#0a2cc4"}
            width="37px"
            height="37px"
          />
        </div>
        <div className={style.social_text_wrap}>
          <div className={style.social_text_title}>페이스북</div>
          <div className={style.social_text_content}>
            리브테크놀로지와 연결되어 더 많은 소식을 만나보세요.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Social;
